import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import Config from '../../assets/js/config';
import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion';

export default {
    name: "TeacherPayment",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
        BadgerAccordion,
        BadgerAccordionItem
    },

    data() {
        return {
            totalFiles: 0,
            fileUpload: null,
            filePreview: null,
            file: null,
            uploadFailed: [],
            isLoading: false,
            images: [],
            submitted: false,
            upload: false,
            validation: false,
            msg: "",
            validationMsg: "",
            originalLength: 0,
            failed: "",
            amount: Config.amount,
            isVisible: false,
            payments: [],
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        onClick() {
            if (this.submitted == true) {
                this.isLoading = true;
            }
        },

        filesChange(uploadedFiles) {
            this.images = [];
            this.fileUpload.files = uploadedFiles;
            this.totalFiles = this.fileUpload.files.length;
            const allowedExtensions = ['jpg', 'jpeg', 'png'];
            const dt = new DataTransfer();
            const input = document.getElementById('files');
            const { files } = input;
            for (let i = 0; i < this.totalFiles; i++) {
                const fileExtension = this.getFileExtension(this.fileUpload.files[i].name);
                if (!allowedExtensions.includes(fileExtension)) {
                    alert(this.fileUpload.files[i].name + " is Invalid file type!");
                    this.fileUpload.files[i].value = "";
                } else {
                    const file = files[i];
                    dt.items.add(file);

                    let fileSource = this.fileUpload.files[i] ? URL.createObjectURL(this.fileUpload.files[i]) : "";

                    this.images.push({ name: this.fileUpload.files[i].name, url: fileExtension, fileSource });
                }
            }
            input.files = dt.files;
            this.totalFiles = input.files.length;
        },

        getFileExtension(filename) {
            return filename.split('.').pop().toLowerCase();
        },

        removeClone(i) {
            var index = this.images.indexOf(this.images[i]);
            this.images.splice(index, 1);

            const dt = new DataTransfer();
            const input = document.getElementById('files');
            const { files } = input;

            for (let j = 0; j < files.length; j++) {
                const file = files[j];
                if (i !== j)
                    dt.items.add(file);
            }
            input.files = dt.files;
            this.totalFiles = input.files.length;
            if (this.totalFiles == 0) {
                this.submitted = false;
                this.upload = true;
            }
        },

        submitFile() {
            this.submitted = true;
            this.upload = false;
            this.isLoading = true;
            this.upload = [];
            this.files = this.$refs.files.files;
            this.originalLength = this.files.length;
            if (this.files.length <= 0) {
                this.msg = "Please Upload File";
            }

            if (this.files.length <= 0) {
                this.isLoading = false;
                this.submitted = false;
                return;
            }
            for (let i = 0; i < this.files.length; i++) {
                this.file = this.$refs.files.files[i];
                this.upload.push(this.file);

                if (this.$refs.files.files[i].size > 0) {
                    let formData = new FormData();
                    let signupForm = JSON.parse(this.$route.query.signupForm);
                    for (let key in signupForm) {
                        formData.append(key, signupForm[key]);
                    }
                    formData.append('file', this.$refs.files.files[i]);
                    var apiUrl = (this.$route.query.type === 'teacher') ? "/register/teacher" : "/register/school";
                    axios.post(apiUrl, formData,
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    ).then((response) => {
                        if (response.data.status == 'failed') {
                            this.failed = 2;
                            this.isLoading = false;
                            this.submitted = false;
                            this.upload = true;
                            this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                                timer: 3,
                                position: "bottomCenter"
                            });
                        } else {
                            const phone_number = response.data.phone_number_1;
                            this.$notification.success("Registration လုပ်ဆောင်ချက်အောင်မြင်ပါသည်။ Register လုပ်ထားသော Password ဖြင့် Login ဝင်ပေးပါ။", {
                                timer: 3,
                                position: 'topCenter'
                            });
                            localStorage.setItem('phoneNo', phone_number);
                            this.$router.push({
                                name: "login"
                            });
                        }
                    })
                        .catch((error) => {
                            if (error.response.status == 401) {
                                this.$store.commit('logout');
                                window.location.replace('/');
                            }
                            this.failed = 2;
                            this.isLoading = false;
                            this.submitted = false;
                            this.upload = true;
                            this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                                timer: 3,
                                position: "bottomCenter"
                            });
                        });
                } else {
                    this.failed = 3;
                    this.isLoading = false;
                    this.submitted = false;
                    this.upload = true;
                    this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                }
            }
        },

        getPaymentDetail() {
            axios.get("/payment-methods")
                .then(response => {
                    this.payments = response.data.data.map(payment => ({
                        ...payment,
                        hidden: true, // Initialize 'hidden' property
                      }));                      
                })
                .catch(error => {
                    console.log(error, "error");
                });
        }, 

        togglePayment(payment) {
            payment.hidden = !payment.hidden;
        },

        showModal() {
            this.isVisible = true;
        },

        closeModal() {
            this.isVisible = false;
        },
    },

    mounted() {
        document.addEventListener('click', this.onClick);
        this.fileUpload = document.getElementById('files');
        this.filePreview = document.getElementById('file_preview');
        this.getPaymentDetail();
    }
};
